import { IReducersMap, reducer } from '../../standard-actions/reducers';
import {
    LOAD_INCIDENTS,
    TICKETS_SUMMARY_LOAD,
    TICKETS_CREATE,
    TICKET_DETAILS_LOAD,
    TICKET_ACTIVITIES_LOAD,
    TICKETS_SERVICE_TYPES_LOAD,
    TICKETS_POST_COMMENT,
    TICKET_PATCH,
    TICKET_ATTACHMENTS_PATCH,
    TICKET_SERVICE_ID_PATCH,
    TICKET_SUMMARY_UPDATE,
    TICKET_CUSTOMER_REFERENCE_UPDATE,
    TICKET_ATTACHMENTS_LIST_UPDATE,
    TICKET_COMPANY_LOAD,
    TICKET_FILE_UPLOAD,
    TICKET_FEATURE_FLAGS,
    TICKET_SESSION_STORAGE_UPDATE,
    TICKET_CUSTOM_SERVICE_ID_UPDATE,
    TICKET_SERVICE_LOCATIONS,
    CLOSE_INCIDENT_PATCH,
    TICKET_REQUESTED_CLOSURE_FLAG_UPDATE,
    TICKET_MAJOR_INCIDENTS,
    TICKET_SELECTED_MAJOR_INCIDENT,
    UPDATE_COVID19_INCIDENT_FLAG,
    USER_MANAGEMENT_FETCH_PROFILE,
    INCIDENTS_FILTER_OPTIONS_LOAD,
    INCIDENTS_FILTER_LOCATIONS_LOAD,
    GLOBAL_INCIDENTS_FILTER_LOCATIONS_LOAD,
    INCIDENTS_TENANCY_IDS_LOAD,
    TICKET_ATTACHMENTS_LOAD,
    TICKET_ATTACHMENTS_DELETE,
    ESCALATE_INCIDENT,
    MERGE_TEST_ID_LOAD,
    MERGE_TEST_RESULTS_LOAD,
    MERGE_TEST_HISTORY_LOAD,
    MERGE_TEST_VALID_SERVICE_ID_LOAD,
    DYNAMIC_FORM_LOAD,
    INT_MERGE_TEST_LOAD,
    MERGE_TEST_IP_VOICE_SERVICE_ID_LOAD,
    MERGE_TEST_IP_VOICE_RESULTS_LOAD,
    GUEST_SERVICE_ADDRESS_LOAD,
    GUEST_SERVICE_ADDRESS_CONTACT_LOAD,
    GUEST_SERVICE_ID_LOAD,
    GUEST_INCIDENTS_LOAD,
    GUEST_INCIDENTS_SUMMARY_LOAD,
    GUEST_INCIDENT_CREATE,
    GUEST_INCIDENT_DETAILS_LOAD,
    RAISED_FOR_LOAD,
    DOWNLOAD_SUMMARY_INT,
    GLOBAL_LOCATION_SERVICE_IDS_LOAD,
    GLOBAL_INCIDENTS_FILTER_OPTIONS_LOAD,
    GLOBAL_INCIDENT_PATCH,
    TRACK_INCIDENTS_LIST_LOAD,
    TRACK_INCIDENTS_LIST_EXPORT,
} from '../actions/action-types';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';
import { incidentsReducer, TicketsAction as IncidentsAction } from './all-incidents-reducer';
import { ticketsSummaryReducer, TicketsAction as SummaryTicketsAction } from './summary-reducer';
import { createTicketReducer, TicketsAction as CreateTicketAction } from './create-ticket';
import { ticketDetailsReducer, TicketsAction as TicketDetailsAction } from './ticket-details-reducer';
import { ticketAttachmentsReducer, TicketsAction as TicketAttachmentsAction } from './ticket-attachments-reducer';
import { deleteAttachmentsReducer, TicketsAction as DeleteAttachmentsAction } from './delete-ticket-attachments';
import { ticketActivitiesReducer, TicketsAction as TicketActivitiesAction } from './ticket-activity-reducer';
import { ticketServiceTypesReducer, TicketsAction as TicketServiceTypesAction } from './service-types';
import { postTicketCommentReducer, PostTicketCommentAction } from './post-ticket-comment';
import { patchTicketReducer, PatchTicketAction } from './patch-ticket';
import { updateTicketSummaryReducer, UpdateTicketSummaryAction } from './ticket-status-reducer';
import {
    updateTicketCustomerReferenceReducer,
    UpdateTicketCustomerReferenceAction
} from './ticket-customer-reference-reducer';
import {
    updateTicketAttachmentsListReducer,
    UpdateTicketAttachmentsListAction
} from './ticket-attachments-list-reducer';
import { ticketsCcvReducer, TicketsAction as CcvTicketsAction } from './ccv-reducer';
import {
    fileUploadTicketReducer,
    FileUploadTicketAction
} from './file-upload-reducer';
import {
    attachTicketReducer,
    AttachTicketAction
} from './patch-ticket-attachments';
import {
    patchServiceIdReducer,
    PatchServiceIdAction
} from './patch-ticket-service-id';
import { ticketsFeatureFlagReducer, TicketsAction as TicketsFeatureFlagAction } from './feature-flag-reducer';
import {
    updateTicketSessionStorageReducer,
    UpdateTicketSessionStorageAction
} from './ticket-session-reducer';
import {
    updateSummaryCustomServiceIdReducer,
    UpdateSummaryCustomServiceIdAction
} from './summary-custom-service-id-reducer';
import {
    serviceLocationSummaryReducer,
    ServiceLocationSummaryAction
} from './service-locations-reducer';
import {
    closeIncidentReducer,
    CloseIncidentAction
} from './close-incident-reducer';
import {
    updateTicketRequestedClosureReducer,
    UpdateTicketRequestedClosureAction
} from './requested-closure-reducer';

import { majorIncidentsReducer, MajorIncidentsAction } from './major-incident-reducer';
import { AddMajorIncidentAction, updateSelectedMajorIncidentReducer } from './selected-major-incident-reducer';
import {
    UpdateCovid19IncidentFlagAction,
    updateCovid19IncidentFlagReducer
} from './updated-covid-incident-flag-reducer';
import { GetUserProfileAction, GetUserProfileReducer } from './user-profile';
import { LoadFilterOptionsAction, filterIncidentsReducer } from './filter-options-reducer';
import { LoadFilterLocationsAction, filterLocationsReducer } from './filter-locations-reducer';
import { LoadMDMTenancyIDsAction, mdmTenancyIDsReducer } from './mdm-tenancy-id-reducer';
import { escalateIncidentReducer, EscalateIncidentAction } from './escalate-incident';
import { mergeTestIdReducer, MergeTestIdAction } from './merge-test-id-reducer';
import { mergeTestResultsReducer, MergeTestResultsAction } from './merge-test-results-reducer';
import { mergeTestHistoryReducer, MergeTestHistoryAction } from './merge-test-history-reducer';
import { ipVoiceMergeTestIdReducer, IpVoiceMergeTestIdAction } from './ip-voice-merge-test-id-reducer';
import { ipVoiceMergeTestResultsReducer, IpVoiceMergeTestResultsAction } from './ip-voice-merge-test-results-reducer';
import {
    mergeTestServiceIdValidationReducer,
    MergeTestServiceIdValidationAction
} from './merge-service-id-validation-reducer';
import { dynamicFormReducer, DynamicFormAction } from './dynamic-form-reducer';
import { intMergeTestReducer, IntMergeTestAction } from './int-merge-test-results-reducer';
import { guestServiceAddressReducer, GuestServiceAddressAction } from './guest/service-address-reducer';
import { guestServiceAddressContactReducer, GuestServiceAddressContactAction } from './guest/service-address-contact-reducer';
import { guestServiceIdReducer, GuestServiceIdAction } from './guest/service-id-reducer';
import { guestIncidentsReducer, GuestIncidentsAction } from './guest/incidents-reducer';
import { guestIncidentsSummaryReducer, GuestIncidentsSummaryAction } from './guest/incidents-summary-reducer';
import { createGuestIncidentReducer, CreateGuestIncidentAction } from './guest/create-incident-reducer';
import { GuestIncidentDetailsAction, guestIncidentDetailsReducer } from './guest/incident-details-reducer';
import { raisedForReducer, RaisedForAction } from './raised-for-reducer';
import { loadDownloadSummaryReducer, IDownloadSummaryFileAction } from './download-summary-int';
import {
    globalLocationServiceIDsReducer,
    GlobalLocationServiceIDsAction
} from './global/location-service-ids-reducer';
import { globalFilterLocationsReducer, LoadGlobalFilterLocationsAction } from './global/filter-locations-reducer';
import { globalFilterIncidentsReducer, LoadGlobalFilterOptionsAction } from './global/filter-options-reducer';
import { patchGlobalIncidentReducer, PatchGlobalIncidentAction } from './global/patch-incident-reducer';
import { LoadIncidentsListAction, loadIncidentsListReducer } from './track-incidents-list';
import { trackIncidentsExportReducer, TrackIncidentsExportTicketAction } from './track-incidents-export';

export type TicketsAction
    = IncidentsAction
    | SummaryTicketsAction
    | CreateTicketAction
    | TicketServiceTypesAction
    | TicketDetailsAction
    | TicketAttachmentsAction
    | DeleteAttachmentsAction
    | TicketActivitiesAction
    | PostTicketCommentAction
    | PatchTicketAction
    | UpdateTicketSummaryAction
    | UpdateTicketCustomerReferenceAction
    | UpdateTicketAttachmentsListAction
    | CcvTicketsAction
    | FileUploadTicketAction
    | AttachTicketAction
    | PatchServiceIdAction
    | TicketsFeatureFlagAction
    | UpdateTicketSessionStorageAction
    | UpdateSummaryCustomServiceIdAction
    | ServiceLocationSummaryAction
    | CloseIncidentAction
    | UpdateTicketRequestedClosureAction
    | MajorIncidentsAction
    | AddMajorIncidentAction
    | UpdateCovid19IncidentFlagAction
    | GetUserProfileAction
    | LoadFilterOptionsAction
    | LoadFilterLocationsAction
    | LoadMDMTenancyIDsAction
    | EscalateIncidentAction
    | MergeTestIdAction
    | MergeTestResultsAction
    | MergeTestHistoryAction
    | MergeTestServiceIdValidationAction
    | DynamicFormAction
    | IntMergeTestAction
    | IpVoiceMergeTestIdAction
    | IpVoiceMergeTestResultsAction
    | GuestServiceAddressAction
    | GuestServiceAddressContactAction
    | GuestServiceIdAction
    | GuestIncidentsAction
    | GuestIncidentsSummaryAction
    | CreateGuestIncidentAction
    | GuestIncidentDetailsAction
    | RaisedForAction
    | IDownloadSummaryFileAction
    | GlobalLocationServiceIDsAction
    | LoadGlobalFilterLocationsAction
    | LoadGlobalFilterOptionsAction
    | PatchGlobalIncidentAction
    | LoadIncidentsListAction
    | TrackIncidentsExportTicketAction;

const reducersMap: IReducersMap<ITicketsState> = {
    [LOAD_INCIDENTS]: incidentsReducer,
    [TICKETS_SUMMARY_LOAD]: ticketsSummaryReducer,
    [TICKETS_CREATE]: createTicketReducer,
    [TICKETS_SERVICE_TYPES_LOAD]: ticketServiceTypesReducer,
    [TICKET_DETAILS_LOAD]: ticketDetailsReducer,
    [TICKET_ATTACHMENTS_LOAD]: ticketAttachmentsReducer,
    [TICKET_ATTACHMENTS_DELETE]: deleteAttachmentsReducer,
    [TICKET_ACTIVITIES_LOAD]: ticketActivitiesReducer,
    [TICKETS_POST_COMMENT]: postTicketCommentReducer,
    [TICKET_PATCH]: patchTicketReducer,
    [TICKET_SUMMARY_UPDATE]: updateTicketSummaryReducer,
    [TICKET_CUSTOMER_REFERENCE_UPDATE]: updateTicketCustomerReferenceReducer,
    [TICKET_ATTACHMENTS_LIST_UPDATE]: updateTicketAttachmentsListReducer,
    [TICKET_COMPANY_LOAD]: ticketsCcvReducer,
    [TICKET_FILE_UPLOAD]: fileUploadTicketReducer,
    [TICKET_ATTACHMENTS_PATCH]: attachTicketReducer,
    [TICKET_FEATURE_FLAGS]: ticketsFeatureFlagReducer,
    [TICKET_SESSION_STORAGE_UPDATE]: updateTicketSessionStorageReducer,
    [TICKET_SERVICE_ID_PATCH]: patchServiceIdReducer,
    [TICKET_CUSTOM_SERVICE_ID_UPDATE]: updateSummaryCustomServiceIdReducer,
    [TICKET_SERVICE_LOCATIONS]: serviceLocationSummaryReducer,
    [CLOSE_INCIDENT_PATCH]: closeIncidentReducer,
    [TICKET_REQUESTED_CLOSURE_FLAG_UPDATE]: updateTicketRequestedClosureReducer,
    [TICKET_MAJOR_INCIDENTS]: majorIncidentsReducer,
    [TICKET_SELECTED_MAJOR_INCIDENT]: updateSelectedMajorIncidentReducer,
    [UPDATE_COVID19_INCIDENT_FLAG]: updateCovid19IncidentFlagReducer,
    [USER_MANAGEMENT_FETCH_PROFILE]: GetUserProfileReducer,
    [INCIDENTS_FILTER_OPTIONS_LOAD]: filterIncidentsReducer,
    [INCIDENTS_FILTER_LOCATIONS_LOAD]: filterLocationsReducer,
    [INCIDENTS_TENANCY_IDS_LOAD]: mdmTenancyIDsReducer,
    [ESCALATE_INCIDENT]: escalateIncidentReducer,
    [MERGE_TEST_ID_LOAD]: mergeTestIdReducer,
    [MERGE_TEST_RESULTS_LOAD]: mergeTestResultsReducer,
    [MERGE_TEST_HISTORY_LOAD]: mergeTestHistoryReducer,
    [MERGE_TEST_VALID_SERVICE_ID_LOAD]: mergeTestServiceIdValidationReducer,
    [DYNAMIC_FORM_LOAD]: dynamicFormReducer,
    [INT_MERGE_TEST_LOAD]: intMergeTestReducer,
    [MERGE_TEST_IP_VOICE_SERVICE_ID_LOAD]: ipVoiceMergeTestIdReducer,
    [MERGE_TEST_IP_VOICE_RESULTS_LOAD]: ipVoiceMergeTestResultsReducer,
    [GUEST_SERVICE_ADDRESS_LOAD]: guestServiceAddressReducer,
    [GUEST_SERVICE_ADDRESS_CONTACT_LOAD]: guestServiceAddressContactReducer,
    [GUEST_SERVICE_ID_LOAD]: guestServiceIdReducer,
    [GUEST_INCIDENTS_LOAD]: guestIncidentsReducer,
    [GUEST_INCIDENTS_SUMMARY_LOAD]: guestIncidentsSummaryReducer,
    [GUEST_INCIDENT_CREATE]: createGuestIncidentReducer,
    [GUEST_INCIDENT_DETAILS_LOAD]: guestIncidentDetailsReducer,
    [RAISED_FOR_LOAD]: raisedForReducer,
    [DOWNLOAD_SUMMARY_INT]: loadDownloadSummaryReducer,
    [GLOBAL_LOCATION_SERVICE_IDS_LOAD]: globalLocationServiceIDsReducer,
    [GLOBAL_INCIDENTS_FILTER_LOCATIONS_LOAD]: globalFilterLocationsReducer,
    [GLOBAL_INCIDENTS_FILTER_OPTIONS_LOAD]: globalFilterIncidentsReducer,
    [GLOBAL_INCIDENT_PATCH]: patchGlobalIncidentReducer,
    [TRACK_INCIDENTS_LIST_LOAD]: loadIncidentsListReducer,
    [TRACK_INCIDENTS_LIST_EXPORT]: trackIncidentsExportReducer
};

export const ticketsReducer = reducer<ITicketsState, TicketsAction>(reducersMap, initialState);
